import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Product, PaginationWeb } from "services/productService";

export interface ProductWebState {
  products: Product[];
  pagination: PaginationWeb | null;
  loading: boolean;
  error: string | null;
}

export const initialState: ProductWebState = {
  products: [],
  pagination: null,
  loading: false,
  error: null,
};

const productWebSlice = createSlice({
  name: "productWeb",
  initialState,
  reducers: {
    setProductWebLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setProductWebData(
      state,
      action: PayloadAction<{ products: Product[]; pagination: PaginationWeb }>
    ) {
      state.products = action.payload.products;
      state.pagination = action.payload.pagination;
      state.error = null;
    },
    setProductWebError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setProductWebLoading,
  setProductWebData,
  setProductWebError,
} = productWebSlice.actions;

export default productWebSlice.reducer;

